import React from "react";

//True once the window has scrolled past the given offset
export const useScrolledPast = (offset) => {
  const [isPast, setIsPast] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setIsPast(window.scrollY > offset);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [offset]);

  return isPast;
};

//Returns the id of the section currently in the middle of the screen (null if none of them are)
export const useActiveSection = (sectionIDs) => {
  const [active, setActive] = React.useState(null);

  React.useEffect(() => {
    if (!("IntersectionObserver" in window)) {
      return undefined;
    }
    const visible = {};
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        visible[entry.target.id] = entry.isIntersecting;
      });
      setActive(sectionIDs.find((id) => visible[id]) || null);
    }, { rootMargin: "-45% 0px -50% 0px" });

    sectionIDs.forEach((id) => {
      const el = document.getElementById(id);
      if (el) {
        observer.observe(el);
      }
    });
    return () => observer.disconnect();
  }, [sectionIDs.join(",")]);

  return active;
};
